import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YahooDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 327" transform="translate(-598.599 -168.336)">
      <rect
        data-name="\u9577\u65B9\u5F62 780"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(598.599 168.336)"
      />
      <path data-name="\u9577\u65B9\u5F62 781" fill="#fff" d="M604.879 207.989h132.072v21.956H604.879z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 325">
        <path
          data-name="\u30D1\u30B9 1031"
          d="M736.87 207.989v-18.011a14.309 14.309 0 00-14.308-14.309h-14.123v1.918a7.586 7.586 0 01-7.586 7.587h-59.117a7.586 7.586 0 01-7.586-7.587v-1.918h-14.962a14.309 14.309 0 00-14.309 14.309v18.011z"
          fill="#fff"
        />
      </g>
      <path
        data-name="\u30D1\u30B9 1032"
        d="M604.879 228.579v219a14.308 14.308 0 0014.309 14.308h103.374a14.308 14.308 0 0014.308-14.308v-219z"
        fill="#fff"
      />
      <path data-name="\u7DDA 5" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M605.055 204.51h131.654" />
      <circle
        data-name="\u6955\u5186\u5F62 467"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(723.141 189.244)"
        fill="#9e9e9e"
      />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 326">
        <path
          data-name="\u30D1\u30B9 1033"
          d="M713.532 188.747H695.82v11.384h17.712a5.714 5.714 0 000-11.384z"
          fill="#1e74ff"
        />
        <path
          data-name="\u30D1\u30B9 1034"
          d="M617.219 188.747a5.714 5.714 0 000 11.384H694.9v-11.384z"
          fill="#e7e7e7"
        />
      </g>
      <path
        data-name="\u30D1\u30B9 1035"
        d="M605.284 430.225v17.613a14.309 14.309 0 0014.309 14.309h103.373a14.309 14.309 0 0014.309-14.309v-17.613z"
        fill="#ebe5e1"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 782"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(652.305 454.36)"
      />
      <circle
        data-name="\u6955\u5186\u5F62 468"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(723.141 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 469"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(686.258 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 470"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(647.638 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 471"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(610.755 435.779)"
        fill="#ec4545"
      />
      <path data-name="\u9577\u65B9\u5F62 783" fill="#eb4441" d="M604.903 206.798h131.914v223.035H604.903z" />
    </g>
  </Root>
);

const Root = styled('svg')();

export default YahooDevice916;
